
		<div dw-tooltip dwPlacement="topLeft" dwOverlayClassName="ag-invalid-cell-overlay"
		     [dwTitle]="errorContent" [dwVisible]="errorVisible"
		     *ngIf="errorVisible"></div>
		<ng-template #errorContent>
			<div *ngFor="let msg of validationMessages">{{ msg.key | translate:msg.params }}</div>
		</ng-template>
		<form [formGroup]="validateForm" [ngClass]="{'invalid-form': formControl.invalid}">
			<dw-form-control>
				<dw-input-group>
					<input [formControl]="formControl" [(ngModel)]="value" hidden>
					<span [ngClass]="{'cell-overlay' : errorVisible}"> {{value}}</span>
				</dw-input-group>
			</dw-form-control>
		</form>
  